import { AudioRecordingModelData } from "@/store/audio-recordings";
import { AudioRecordingRetranscriptionStatus } from "@/store/audio-recordings/types";
import {
  BaseAudioRecordingAppEventOperation,
  BaseAudioRecordingAppEventOperationParams,
} from "./BaseAudioRecordingAppEventOperation";

/**
 * Operation to mark that an audio recording has completed the retranscription process.
 * This is called after successfully retranscribing from the uploaded audio.
 */
export class MarkCompletedRetranscribingAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind() {
    return "MARK_COMPLETED_RETRANSCRIBING_AUDIO_RECORDING" as const;
  }

  constructor(params: BaseAudioRecordingAppEventOperationParams) {
    super(params);
  }

  protected getModelDataUpdates(
    _existingData: AudioRecordingModelData
  ): Partial<AudioRecordingModelData> {
    return {
      retranscription_status: AudioRecordingRetranscriptionStatus.COMPLETED,
    };
  }
}
